(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mda-samplepack-codeinfo"] && !Shopify.designMode) return;
  try {
    (function () {
  function parts(root) {
    return { btn: root.querySelector('[data-mda-codeinfo-toggle]'), pop: root.querySelector('.mda-spcodeinfo__pop') };
  }
  function setOpen(root, open) {
    var p = parts(root);
    if (!p.btn || !p.pop) return;
    p.pop.hidden = !open;
    p.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) root.removeAttribute('data-pinned');
  }
  function closeAll(except) {
    document.querySelectorAll('[data-mda-codeinfo]').forEach(function (root) {
      if (root !== except) setOpen(root, false);
    });
  }
  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-mda-codeinfo-copy]');
    if (copy) {
      var code = copy.getAttribute('data-mda-codeinfo-copy');
      if (code && navigator.clipboard) {
        navigator.clipboard.writeText(code).then(function () {
          copy.classList.add('is-copied');
          setTimeout(function () { copy.classList.remove('is-copied'); }, 2000);
        });
      }
      return;
    }
    var toggle = e.target.closest('[data-mda-codeinfo-toggle]');
    if (toggle) {
      var root = toggle.closest('[data-mda-codeinfo]');
      closeAll(root);
      if (root.hasAttribute('data-pinned')) {
        setOpen(root, false);
      } else {
        setOpen(root, true);
        root.setAttribute('data-pinned', '');
      }
      return;
    }
    if (!e.target.closest('[data-mda-codeinfo]')) closeAll(null);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
  if (window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var root = e.target.closest('[data-mda-codeinfo]');
      if (root && e.target.closest('[data-mda-codeinfo-toggle], .mda-spcodeinfo__pop')) setOpen(root, true);
    });
    document.addEventListener('mouseout', function (e) {
      var root = e.target.closest('[data-mda-codeinfo]');
      if (!root || root.hasAttribute('data-pinned')) return;
      if (e.relatedTarget && root.contains(e.relatedTarget)) return;
      setOpen(root, false);
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mda-samplepack-credit"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
  var opener = e.target.closest('[data-mda-spcredit-open]');
  if (opener) {
    var dlg = document.getElementById(opener.getAttribute('data-mda-spcredit-open'));
    if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    return;
  }
  if (e.target.closest('[data-mda-spcredit-close]')) {
    e.target.closest('dialog').close();
    return;
  }
  if (e.target.classList && e.target.classList.contains('mda-spcredit-drawer')) e.target.close();
});
  } catch(e) { console.error(e); }
})();

})();
